export default function InvoiceCustomerCard({
  customer,
  invoice,
}) {
  const name =
    customer?.name ||
    invoice?.customer_name ||
    "Cliente general";

  const document =
    customer?.document ||
    customer?.document_number ||
    invoice?.customer_document ||
    "-";

  const email =
    customer?.email ||
    invoice?.customer_email ||
    "-";

  return (
    <section className="invoice-data-card">
      <h3>Cliente</h3>

      <dl>
        <div>
          <dt>Nombre</dt>
          <dd>{name}</dd>
        </div>

        <div>
          <dt>Documento</dt>
          <dd>{document}</dd>
        </div>

        <div>
          <dt>Correo</dt>
          <dd>{email}</dd>
        </div>

        <div>
          <dt>Teléfono</dt>
          <dd>{customer?.phone || "-"}</dd>
        </div>

        <div>
          <dt>Dirección</dt>
          <dd>{customer?.address || "-"}</dd>
        </div>
      </dl>
    </section>
  );
}